import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import { getMessageDescriptorOrStringFromErrorString } from '../../errors/user-friendly-error-message-service/error-string-matching-to-formatted-message';

const FORMATTED_MESSAGE = 'FormattedMessage';

const Message = ({ errorMessage, childClassName }) => {
  const messageDescriptorOrString = getMessageDescriptorOrStringFromErrorString(errorMessage);
  if (typeof messageDescriptorOrString === 'object') {
    const msgType = messageDescriptorOrString.type?.displayName;
    // we intercept error messages from the backend and provide a user
    // friendly message upstream from this component.  Here we are attempting
    // to identify that the element is already a FormattedMessage component
    if (msgType === FORMATTED_MESSAGE) {
      return messageDescriptorOrString;
    }
    return (
      <div className={childClassName}>
        <FormattedMessage {...messageDescriptorOrString} />
      </div>
    );
  }
  return <div className={childClassName}>{messageDescriptorOrString}</div>;
};

Message.propTypes = {
  errorMessage: PropTypes.oneOfType([PropTypes.string, MessageDescriptorPropType]).isRequired,
  childClassName: PropTypes.object.isRequired,
};

export default Message;
